import { Component, OnInit } from '@angular/core';
import {ConceptService} from '../../core/concept.service';
import {PrimusRouterService} from '../../core/primus-router.service';
import {ConceptsContainer} from '../../core/definitions/concepts-container';

@Component({
  selector: 'app-admin-agent',
  templateUrl: './admin-agent.component.html',
  styleUrls: ['./admin-agent.component.scss']
})
export class AdminAgentComponent implements OnInit {

  constructor(private conceptService: ConceptService,
              private primusRouter: PrimusRouterService) { }

  conceptsContainer: ConceptsContainer;
  parent;

  ngOnInit(): void {
    this.setAgentConceptsContainer().then();
    this.parent = {
      path: 'admin',
      adminType: 'agent',
      hasSubMenus: true,
      target_params: {admin_type: 'agent'},
      currentState: this.primusRouter.currentState()
    };
  }

  async setAgentConceptsContainer() {
    const conceptType = await this.conceptService.getConceptType('agent');
    this.conceptService.setConceptsContainer(conceptType).then(conceptsContainer => {
      this.conceptsContainer = conceptsContainer;
      this.conceptsContainer.showLinkToObject = true;
    });

  }

}
